window.onload = function() {
  console.log('... cargando aplicacion ...');
}

window.addEventListener("load", function(event) {
  var element = document.getElementById("progress-bar")
  element.style.display = 'none';
});